// index.js
import { AuthProvider } from "react-oidc-context";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";  // Make sure to import the App component

const cognitoAuthConfig = {
  authority: "https://cognito-idp.eu-central-1.amazonaws.com/eu-central-1_ZtOXHwoNz",
  client_id: "7p4djil0soacn5foe6tgqc00cr",
  redirect_uri: "https://employee.currentix.de/callback",
  response_type: "code",
  scope: "email openid phone",
};

const root = ReactDOM.createRoot(document.getElementById("root"));

// wrap the application with AuthProvider
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);